import styled from '@emotion/styled';
import { ChatMessagesViewProps } from './types';
import ChatThinking from './Layout/ChatThinking/ChatThinking';
import ChatMessage from './Layout/ChatMessage';

const MAX_WIDTH = 820; // Maximum width for the chat messages container

const ChatMessagesContainer = styled.div`
  margin-top: 88px;
  height: 100%;
  min-height: 400px;
  max-height: 100%;
  overflow-y: auto;

  width: 100%;
  padding: 0 calc(100% - 774px);

  display: flex;
  flex-direction: column;
  gap: 32px;

  /* this keeps the margins consistent with the ChatTextbox when resizing */
  padding-left: max(32px, calc((100% - ${MAX_WIDTH}px) / 2));
  padding-right: max(32px, calc((100% - ${MAX_WIDTH}px) / 2));
  & img {
    max-width: 100%;
  }
`;

const ChatMessagesView = (props: ChatMessagesViewProps) => {
  const { messages, loading, container, onFeedbackClick } = props;

  return (
    <ChatMessagesContainer ref={container}>
      {messages.map((message) => (
        <ChatMessage key={message.id} {...message} onFeedbackClick={onFeedbackClick} />
      ))}
      {loading && <ChatThinking />}
    </ChatMessagesContainer>
  );
};

export default ChatMessagesView;
